import api from "../../../axiosConfig";

/**
 * Company/brand email signature.
 * - get():   any authenticated user (the composer uses it to know if one exists)
 * - upload() / remove(): admin only (enforced by the backend gate)
 */
export const companySignatureApi = {
  get: async () => {
    const res = await api.get("/company-signature");
    return res.data; // { company_signature_url, exists }
  },

  upload: async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    const res = await api.post("/admin/company-signature", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data; // { company_signature_url, exists }
  },

  remove: async () => {
    const res = await api.delete("/admin/company-signature");
    return res.data; // { company_signature_url: null, exists: false }
  },
};
